import React from 'react'

const styles = {
    divider: {
        borderBottom: '1px solid #d8d8d8',
    },
}

const Divider = ({marginTop}) => {
    return <div style={{...styles.divider, marginTop: marginTop }} />
}

export default Divider
